module.exports = __webpack_public_path__ + "img/slider-image-03-pluska.d5343803.png";